import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { useCorvusEventList } from "@emerald-works/react-event-bus-client";
import useNavigation from "../../../helpers/useNavigation";
import { useAlert } from "../../../hooks";
import OrgForm from "../components/form";
import { clientSlice } from "../../../reducers";
import Forbidden from "../../403";
import ability from "../../../config/ability";

const OrganisationCreatePage = () => {
  const navigate = useNavigation();
  const { showSuccessAlert, showErrorAlert } = useAlert();

  const [createOrg] = useCorvusEventList([{
    eventName: clientSlice.eventBus.createOrg.eventName,
    // Only report success once the backend has actually finished provisioning the org,
    // then return to the list WITHOUT suppressing its fetch so the new org shows up.
    onSuccess: () => {
      showSuccessAlert("Success!", "The organisation has been created.");
      navigate("/dashboard/organisations");
    },
    // Surface failures instead of silently showing success. The user stays on the form
    // so they can retry.
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error("createOrg error", error);
      showErrorAlert(
        "Organisation not created",
        "Something went wrong while creating the organisation. Please try again, or contact support if it keeps happening."
      );
    },
  }]);

  const handleCancelButton = () => {
    navigate("/dashboard/organisations");
  };

  const onSubmit = (org, licenses) => {
    createOrg.trigger({ org, licenses });
  };

  const isSuperAdmin = ability.can("view", "superAdminView");

  return !isSuperAdmin ? (
    <Forbidden />
  ) : (
    <OrgForm
      onSubmit={onSubmit}
      onCancel={handleCancelButton}
      loadingMessage="Creating Organisation..."
      loadingView={createOrg.isWorking}
      defaultValues={{
        id: "",
        name: "",
        orgAdminEmail: [
          {
            adminEmail: "",
          },
        ],
        personalFields: [{ id: uuidv4(), label: "", type: "input", aggregatable: true, options: [{ id: uuidv4(), value: '' }] }],
        occupationFields: [{ id: uuidv4(), label: "", type: "input", aggregatable: true, options: [{ id: uuidv4(), value: '' }] }],
        hierarchyField: {
          enabled: false,
          label: '',
          options: [
            { id: uuidv4(), label: 'Role name 1', value: 100 },
            { id: uuidv4(), label: 'Role name 2', value: 200 },
            { id: uuidv4(), label: 'Role name 3', value: 300 }
          ]
        },
        licenses: [],
      }}
    />
  );
};
export default OrganisationCreatePage;
